export default __webpack_public_path__ + "static/media/schedule_experience_illustration.8786374b.svg";